export const CENSORED_LOANREQUEST_STATUSES = {
    FAILED: 'failed',
    PENDING: 'pending',
    SUCCEEDED: 'succeeded',
} as const;

export const CENSORED_APPLICANT_STATUSES = {
    FAILED: 'failed',
    PENDING: 'pending',
    SUCCEEDED: 'succeeded',
} as const;

export const DEFAULT_CENSOR_MASK = '****' as const;

export const CENSOR_MASKS = {
    // Consors-specific fields - must pass Consors validation schemas
    CONSORS_BIRTH_NAME: 'Censored',
    CONSORS_FIRST_LAST_NAME: 'Censored',
    CONSORS_PLACE_OF_BIRTH: 'Censored',
    CONSORS_STREET: 'Censored',
    // Email fields - must be valid email format
    EMAIL: 'censored@example.com',
    // IBAN fields - must be valid IBAN format (DE + 2 check digits + 18 digits = 22 chars)
    IBAN: 'DE00000000000000000000',
    // Telephone fields - must match telephone format (German format: 017612341234)
    TELEPHONE: '000000000000',
} as const;
